export default __webpack_public_path__ + "7ab9396038b4befda4354b2a476d9064.svg";